import React from 'react';
import PropTypes from 'prop-types';
import { Switch } from 'antd';
import { Box, Text } from '../../../shared/components';
import TwoColumnsFlexLayout from '../../../shared/components/layout/TwoColumnsFlex.layout';

const SubscripcionToggleList = ({ subscripciones, onChange, disabled }) => {


  const subcripcionesList = subscripciones.map((subscripcion) => {
    const { description, usuarioActiva: activa, subId: id } = subscripcion;

    return (
      <Box pt="16" key={id}>
        <TwoColumnsFlexLayout
          leftContent={
            <Text color="white">{description}</Text>
          }
          rightContent={(
            <Switch
              onChange={event => onChange({ value: event, id })}
              style={{ float: 'right' }}
              size="small"
              checked={activa}
              disabled={disabled}
            />
          )}
        />
      </Box>
    );
  });

  return (
    <Box>
      {subcripcionesList}
    </Box>
  )
};


export default SubscripcionToggleList;

SubscripcionToggleList.propTypes = {
  disabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  subscripciones: PropTypes.any.isRequired,
}
